import CenterCenterStack from './CenterCenterStack';

export default CenterCenterStack;
